export function getMondayInUTC(): Date {
  const today: Date = new Date();
  const dayOfWeek: number = today.getDay(); // 0 for Sunday, 1 for Monday, etc.

  const daysToMonday: number = (dayOfWeek === 0) ? -1 : (dayOfWeek - 1);
  const monday: Date = new Date(today);
  monday.setDate(today.getDate() - daysToMonday);
  monday.setHours(0, 0, 0, 0);
  const utcMonday: Date = new Date(monday.getTime() - monday.getTimezoneOffset() * 60000);

  return monday;

}
